import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import PropTypes from "prop-types";

import { fetchEligibilityConditions } from "../../features/condition/conditionActions";
import { ApplicationState } from "../../redux/initialState";
import { Condition } from "../../features/condition/conditionTypes";
import { SelectedCondition } from "../../features/conditionFilter/selectedConditionTypes";
import { updateConditionFilter } from "../../features/conditionFilter/selectedConditionActions";

import { Dropdown, DropdownOptions } from "@tal-gel/components-v2";
interface PropsFromState {
  loading: boolean;
  data: Condition[];
  errors?: string;
}

interface propsFromDispatch {
  fetchEligibilityConditions: () => any;
  updateConditionFilter: (SelectedCondition: any) => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const ConditionSelect: React.FC<AllProps> = ({ data, fetchEligibilityConditions, updateConditionFilter }) => {
  //needed to remember values when open / close mobile modal
  const [selectedOptions, setSelectedOptions] = useState<DropdownOptions>([]);

  useEffect(() => {
    if (!data.length) {
      fetchEligibilityConditions();
    }
  }, [data.length, fetchEligibilityConditions]);

  // Add a Select All option
  const selectAllOption = { value: "__select_all__", label: "All Conditions" };
  const options: DropdownOptions = [selectAllOption, ...data.map(item => ({ value: item.id, label: item.externalName }))];

  const UpdateFilter = (selected: DropdownOptions = []) => {
    const isSelectAll = selected.some(option => option.value === "__select_all__");
    const wasSelectAll = (selectedOptions ?? []).some(option => option.value === "__select_all__");
    let newSelectedOptions: DropdownOptions;
    let values: string[];

    if (isSelectAll) {
      // If Select All is selected, include Select All and all other options
      newSelectedOptions = options;
      values = options.filter(option => option.value !== "__select_all__").map(option => String(option.value));
    } else if (wasSelectAll) {
      // If Select All was previously selected and now is not, clear all selections
      newSelectedOptions = [];
      values = [];
    } else {
      // Normal selection
      newSelectedOptions = selected.filter(option => option.value !== "__select_all__");
      values = newSelectedOptions.map(option => String(option.value));
    }

    setSelectedOptions(newSelectedOptions);
    const selectedCondition: SelectedCondition = {
      data: values,
    };
    updateConditionFilter(selectedCondition);
  };

  return (
    <Dropdown
      errorMessage=""
      id="dropdown_id"
      label="conditionDropdown"
      multiple
      onSelect={UpdateFilter}
      options={options}
      value={selectedOptions}
      placeholder="Select"
    />
  );
};

const mapStateToProps = ({ condition }: ApplicationState) => ({
  loading: condition.loading,
  errors: condition.errors,
  data: condition.data,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchEligibilityConditions: () => {
      dispatch(fetchEligibilityConditions());
    },
    updateConditionFilter: (selectedCondition: SelectedCondition) => {
      dispatch(updateConditionFilter(selectedCondition));
    },
  };
};

ConditionSelect.propTypes = {
  loading: PropTypes.any,
  data: PropTypes.any.isRequired,
  errors: PropTypes.string,
  fetchEligibilityConditions: PropTypes.func.isRequired,
  updateConditionFilter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionSelect);
